import React from "react";

import MetaTags from "react-meta-tags";

const FreeHostingforSchool = () => {
  return (
    <div>
      <MetaTags>
        <title>Set Title</title>
        <meta
          name="description"
          content="Idatahost is the best web hosting provider"
        />
      </MetaTags>
      <div className="main">
        {/*page header section start*/}
        <section className="ptb-120 gradient-bg">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-md-7 col-lg-8">
                <div className="hero-content-wrap text-white text-center position-relative">
                  <h1 className="text-white">
                    {" "}
                    Free Web Hosting Package for School
                  </h1>
                  <p className="lead">
                    Choose your hosting plan and it is low in price from regular
                    market price. You’ll have all the simplicity, dependability,
                    speed, and protection you need to create your website and
                    publish it to the world.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/*page header section end*/}

        {/*pricing section start*/}
        <section id="pricing" className="pricing-section ptb-100">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-md-9 col-lg-8">
                <div className="section-heading text-center mb-4">
                  <h2>Choose Plan for your Institution</h2>
                  <p className="lead">
                    Authenticate your identity and enjoy exciting offer.
                  </p>
                </div>
              </div>
            </div>
            <div className="row align-items-center justify-content-md-center justify-content-center">
              <div className="col-lg-3 col-md-6 col-sm-8">
                <div className="feature-price text-center bg-white single-pricing-pack-2 price-2 mt-4 rounded border">
                  <span className="label-corner primary-bg">Starter</span>
                  <h6 className="mb-4">EDU-1</h6>
                  <div className="pricing-price pb-4">
                    <div className="h2 mb-0">
                      $0.99 <span className="price-cycle h4">/year</span>
                    </div>
                    <div>
                      <span className="pricing-onsale ">100% Off</span>
                    </div>
                  </div>
                  <div className="pricing-content">
                    <ul
                      style={{ textAlign: "left" }}
                      className="list-unstyled tech-feature-list">
                      <li className="py-1">
                        <span className="fas fa-check-circle text-success mr-2"></span>
                        <strong>Unlimited</strong> &nbsp; Website
                      </li>
                      <li>
                        <span className="fas fa-check-circle text-success mr-2"></span>
                        <strong>Unmetered</strong>&nbsp;SSD
                      </li>
                      <li>
                        <span className="fas fa-check-circle text-success mr-2"></span>
                        <strong className="text-under-line">Unmetered</strong>
                        &nbsp; Bandwidth
                      </li>
                      <li>
                        <span className="fas fa-check-circle text-success mr-2"></span>
                        <strong>Free</strong>&nbsp; SSL
                      </li>
                      <li>
                        <span className="fas fa-check-circle text-success mr-2"></span>
                        <strong>Free</strong> CDN
                      </li>
                      <li>
                        <span className="fas fa-check-circle text-success mr-2"></span>
                        Domain Name
                      </li>
                      <li>
                        <span className="fas fa-check-circle text-success mr-2"></span>
                        100% Uptime Guarantee
                      </li>
                      <li>
                        <span className="fas fa-check-circle text-success mr-2"></span>
                        Unlimited Subdomains
                      </li>
                      <li>
                        <span className="fas fa-check-circle text-success mr-2"></span>
                        600000 File Limit
                      </li>
                    </ul>
                    <a
                      href="https://cp.idatahost.com/login"
                      className="btn btn-brand-01"
                      target="_blank">
                      Order Now
                    </a>
                  </div>
                </div>
              </div>

              <div className="col-lg-3 col-md-6 col-sm-8">
                <div className="popular-price text-center bg-white single-pricing-pack-2 price-2 mt-4 rounded border">
                  <h6 className="mb-4">EDU-2</h6>
                  <div className="pricing-price pb-4">
                    <div className="h2 mb-0">
                      $1.58 <span className="price-cycle h4">/mo</span>
                    </div>
                    <div>
                      <span className="pricing-onsale ">
                        45% Off -
                        <span className="badge color-3 color-3-bg priceTextWp">
                          $9.99/year
                        </span>
                      </span>
                    </div>
                  </div>
                  <div className="pricing-content">
                    <ul
                      style={{ textAlign: "left" }}
                      className="list-unstyled tech-feature-list">
                      <li className="py-1">
                        <span className="fas fa-check-circle text-success mr-2"></span>
                        <strong>Unlimited</strong> &nbsp; Website
                      </li>
                      <li>
                        <span className="fas fa-check-circle text-success mr-2"></span>
                        <strong>Unmetered</strong>&nbsp;SSD
                      </li>
                      <li>
                        <span className="fas fa-check-circle text-success mr-2"></span>
                        <strong className="text-under-line">Unmetered</strong>
                        &nbsp; Bandwidth
                      </li>
                      <li>
                        <span className="fas fa-check-circle text-success mr-2"></span>
                        <strong>Free</strong>&nbsp; SSL
                      </li>
                      <li>
                        <span className="fas fa-check-circle text-success mr-2"></span>
                        <strong>Free</strong> CDN
                      </li>
                      <li>
                        <span className="fas fa-check-circle text-success mr-2"></span>
                        Domain Name
                      </li>
                      <li>
                        <span className="fas fa-check-circle text-success mr-2"></span>
                        100% Uptime Guarantee
                      </li>
                      <li>
                        <span className="fas fa-check-circle text-success mr-2"></span>
                        Unlimited Subdomains
                      </li>
                      <li>
                        <span className="fas fa-check-circle text-success mr-2"></span>
                        600000 File Limit
                      </li>
                    </ul>
                    <a
                      href="https://cp.idatahost.com/login"
                      className="btn btn-brand-01"
                      target="_blank">
                      Order Now
                    </a>
                  </div>
                </div>
              </div>
              <div className="col-lg-3 col-md-6 col-sm-8">
                <div className="popular-price text-center bg-white single-pricing-pack-2 price-2 mt-4 rounded border">
                  <h6 className="mb-4">EDU-3</h6>
                  <div className="pricing-price pb-4">
                    <div className="h2 mb-0">
                      $2.68 <span className="price-cycle h4">/mo</span>
                    </div>
                    <div>
                      <span className="pricing-onsale ">
                        40% Off -
                        <span className="badge color-3 color-3-bg priceTextWp">
                          $18.99/year
                        </span>
                      </span>
                    </div>
                  </div>
                  <div className="pricing-content">
                    <ul
                      style={{ textAlign: "left" }}
                      className="list-unstyled tech-feature-list">
                      <li className="py-1">
                        <span className="fas fa-check-circle text-success mr-2"></span>
                        <strong>Unlimited</strong> &nbsp; Website
                      </li>
                      <li>
                        <span className="fas fa-check-circle text-success mr-2"></span>
                        <strong>Unmetered</strong>&nbsp;SSD
                      </li>
                      <li>
                        <span className="fas fa-check-circle text-success mr-2"></span>
                        <strong className="text-under-line">Unmetered</strong>
                        &nbsp; Bandwidth
                      </li>
                      <li>
                        <span className="fas fa-check-circle text-success mr-2"></span>
                        <strong>Free</strong>&nbsp; SSL
                      </li>
                      <li>
                        <span className="fas fa-check-circle text-success mr-2"></span>
                        <strong>Free</strong> CDN
                      </li>
                      <li>
                        <span className="fas fa-check-circle text-success mr-2"></span>
                        Domain Name
                      </li>
                      <li>
                        <span className="fas fa-check-circle text-success mr-2"></span>
                        100% Uptime Guarantee
                      </li>
                      <li>
                        <span className="fas fa-check-circle text-success mr-2"></span>
                        Unlimited Subdomains
                      </li>
                      <li>
                        <span className="fas fa-check-circle text-success mr-2"></span>
                        600000 File Limit
                      </li>
                    </ul>
                    <a
                      href="https://cp.idatahost.com/login"
                      className="btn btn-brand-01"
                      target="_blank">
                      Order Now
                    </a>
                  </div>
                </div>
              </div>

              <div className="col-lg-3 col-md-6 col-sm-8">
                <div className="popular-price text-center bg-white single-pricing-pack-2 price-2 mt-4 rounded border">
                  <h6 className="mb-4">EDU 4</h6>
                  <div className="pricing-price pb-4">
                    <div className="h2 mb-0">
                      $4.80 <span className="price-cycle h4">/mo</span>
                    </div>
                    <div>
                      <span className="pricing-onsale ">
                        46% Off -
                        <span className="badge color-3 color-3-bg priceTextWp">
                          $57.6/year
                        </span>
                      </span>
                    </div>
                  </div>
                  <div className="pricing-content">
                    <ul
                      style={{ textAlign: "left" }}
                      className="list-unstyled tech-feature-list">
                      <li className="py-1">
                        <span className="fas fa-check-circle text-success mr-2"></span>
                        <strong>Unlimited</strong> &nbsp; Website
                      </li>
                      <li>
                        <span className="fas fa-check-circle text-success mr-2"></span>
                        <strong>Unmetered</strong>&nbsp;SSD
                      </li>
                      <li>
                        <span className="fas fa-check-circle text-success mr-2"></span>
                        <strong className="text-under-line">Unmetered</strong>
                        &nbsp; Bandwidth
                      </li>
                      <li>
                        <span className="fas fa-check-circle text-success mr-2"></span>
                        <strong>Free</strong>&nbsp; SSL
                      </li>
                      <li>
                        <span className="fas fa-check-circle text-success mr-2"></span>
                        <strong>Free</strong> CDN
                      </li>
                      <li>
                        <span className="fas fa-check-circle text-success mr-2"></span>
                        Domain Name
                      </li>
                      <li>
                        <span className="fas fa-check-circle text-success mr-2"></span>
                        100% Uptime Guarantee
                      </li>
                      <li>
                        <span className="fas fa-check-circle text-success mr-2"></span>
                        Unlimited Subdomains
                      </li>
                      <li>
                        <span className="fas fa-check-circle text-success mr-2"></span>
                        600000 File Limit
                      </li>
                    </ul>
                    <a
                      href="https://cp.idatahost.com/login"
                      className="btn btn-brand-01"
                      target="_blank">
                      Order Now
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/*pricing section end*/}

        {/*feature section start*/}
        <section className="feature-section ptb-100">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-md-9 col-lg-8">
                <div className="section-heading text-center">
                  <h2>Best Hosting Features For You</h2>
                  <p className="lead">
                    These features come standard in all of our hosting plans.
                    Dynamically extend imperatives through open-source quickly
                    niche markets.
                  </p>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-6 col-lg-4">
                <div className="features-box border p-4 rounded">
                  <div className="features-box-icon mb-3">
                    <span className="ti-timer icon-size-md color-primary"></span>
                  </div>
                  <div className="features-box-content">
                    <h5>100% Uptime Guarantee</h5>
                    <p>
                      The best ability is functionality, so we make sure your
                      site is up and running at all times. We do not see our
                      profit, we assure our client priority
                    </p>
                  </div>
                </div>
              </div>

              <div className="col-md-6 col-lg-4">
                <div className="features-box border p-4 rounded">
                  <div className="features-box-icon mb-3">
                    <span className="ti-thumb-up icon-size-md color-primary"></span>
                  </div>
                  <div className="features-box-content">
                    <h5>Easy installation </h5>
                    <p>
                      you can install in a way that is easier and simple to you.
                      You can install all things that you needed so faster.
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-md-6 col-lg-4">
                <div className="features-box border p-4 rounded">
                  <div className="features-box-icon mb-3">
                    <span className="ti-mouse-alt icon-size-md color-primary"></span>
                  </div>
                  <div className="features-box-content">
                    <h5>SSL certificate</h5>
                    <p>
                      Secure links protect private information, e-commerce
                      payments, and other confidential material.
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-md-6 col-lg-4">
                <div className="features-box border p-4 rounded">
                  <div className="features-box-icon mb-3">
                    <span className="ti-panel icon-size-md color-primary"></span>
                  </div>
                  <div className="features-box-content">
                    <h5>Fast web site</h5>
                    <p>
                      We provide you the best and fast web site. Because User
                      experience is impacted by page rate, this can make or
                      break your site. A faster loading speed improves the user
                      experience by increasing page views, conversions, and
                      lowering the bounce rate.
                    </p>
                  </div>
                </div>
              </div>

              <div className="col-md-6 col-lg-4">
                <div className="features-box border p-4 rounded">
                  <div className="features-box-icon mb-3">
                    <span className="ti-harddrives icon-size-md color-primary"></span>
                  </div>
                  <div className="features-box-content">
                    <h5>Free 3GB space</h5>
                    <p>
                      We give you free 3GB space from the beginning and it is
                      great opportunity for you. You do not get this kind of
                      service from any other services. But we give you that
                      because of your flexibility. Now here is one point and
                      that is if you need more space you have to buy the space
                      from hosting plan, we bring here one more surprise for you
                      that is we give you the space in very minimum price which
                      is unbelievable for you. Never miss this kind of
                      opportunity.
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-md-6 col-lg-4">
                <div className="features-box border p-4 rounded">
                  <div className="features-box-icon mb-3">
                    <span className="ti-cup icon-size-md color-primary"></span>
                  </div>
                  <div className="features-box-content">
                    <h5>Technical free consultation</h5>
                    <p>
                      We have experience group which is waiting for you all the
                      time. If you need any information then you can ask them or
                      you have to need any help that time you can communicate
                      with them. From this you can solve your problem and you
                      can get other needs. We give you 24/7/365 support that is
                      affordable.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/*feature section end*/}

        {/*call to action new section start*/}
        <section className="ptb-60 primary-bg">
          <div className="container">
            <div className="row align-items-center justify-content-between">
              <div className="col-12 col-lg-6">
                <div className="cta-content-wrap text-white">
                  <h2 className="text-white">
                    24/7 Expert Hosting Support Our Customers Love
                  </h2>
                  <p>
                    Objectively innovate high compellingly maintain
                    progressively pursue mission-critical information quality
                    imperatives.
                  </p>
                </div>
                <div className="support-action d-inline-flex flex-wrap">
                  <a href="mailto:support@yourdomain.com" className="mr-3">
                    <i className="fas fa-comment mr-1 color-accent"></i>
                    <span>support@idatahost.com</span>
                  </a>
                  <a href="tel:+00123456789" className="mb-0">
                    <i className="fas fa-phone-alt mr-1 color-accent"></i>
                    <span>+880 1400 88 34 00</span>
                  </a>
                </div>
              </div>
              <div className="col-md-6 col-lg-4 d-none d-lg-block">
                <div className="cta-img-wrap text-center">
                  <img
                    src="assets/img/call-center-support.svg"
                    width="250"
                    className="img-fluid"
                    alt="server room"
                  />
                </div>
              </div>
            </div>
          </div>
        </section>
        {/*call to action new section end*/}

        {/*faq new style start*/}
        <section id="faq" className="ptb-100 gray-light-bg">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-md-9 col-lg-8">
                <div className="section-heading text-center mb-5">
                  <h2>Frequently Asked Queries</h2>
                  <p>
                    Efficiently productivate reliable paradigms before
                    ubiquitous models. Continually utilize frictionless
                    expertise whereas tactical relationships. Still have
                    questions? Contact us
                  </p>
                </div>
              </div>
            </div>
            <div className="row align-items-center">
              <div className="col-md-12 col-lg-12">
                <div id="accordion" className="accordion faq-wrap">
                  <div className="card mb-3">
                    <a
                      className="card-header"
                      data-toggle="collapse"
                      href="#collapse0"
                      aria-expanded="false">
                      <h6 className="mb-0 d-inline-block">What is hosting?</h6>
                    </a>
                    <div
                      id="collapse0"
                      className="collapse show"
                      data-parent="#accordion">
                      <div className="card-body white-bg">
                        <p>
                          The business of hosting, serving, and managing files
                          for one or more Web pages is known as hosting. Web
                          hosting gives your website web space (bandwidth, disk
                          space, RAM, and uptime) and stores all of your
                          website's web pages on its server. The primary goal of
                          web hosting is to make your website available to
                          users. Web hosting is the most important thing to
                          consider if you want to build a website.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="card my-3">
                    <a
                      className="card-header collapsed"
                      data-toggle="collapse"
                      href="#collapse1"
                      aria-expanded="false">
                      <h6 className="mb-0 d-inline-block">
                        Why choose iDATA HOST?
                      </h6>
                    </a>
                    <div
                      id="collapse1"
                      className="collapse"
                      data-parent="#accordion">
                      <div className="card-body white-bg">
                        <p>
                          iDATA HOST has been starting to provide web hosting
                          services since 2008, Mother company FRA Technology and
                          has a renowned as a dependable web hosting provider.
                          We have 365/24/7 support to solve or help with any
                          issues in our any client. Our experience and
                          professional IT experts and staffs, proven reliable
                          client and track records which will give you to obtain
                          as a strong platform for web hosting and development.
                          For these reasons you can choose iDATA HOST as a
                          reliable company.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/*faq new style end*/}
      </div>
    </div>
  );
};

export default FreeHostingforSchool;
